import { jsx as _jsx } from "react/jsx-runtime";
var Container = function (props) { return (_jsx("div", { style: {
        position: "fixed",
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        padding: "0 1em",
        pointerEvents: "none",
        boxSizing: "border-box",
        fontSize: "var(--base-font-size, 16px)",
    }, children: props.children })); };
export default Container;
